/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export default class QCache {
    constructor() {
        this.dbName = 'qcache';
        this.docName = 'req';
    }

    open(path, req, successCallback, errorCallback, version) {
        if(!version) version = 1;
        const conn = indexedDB.open(this.dbName, version);
        conn.onerror = (event) => {
            errorCallback(event);
        };
        conn.onupgradeneeded = (event) => {
            const db = event.target.result;

            if (!db.objectStoreNames.contains(this.docName)) {
                db.createObjectStore(this.docName, { keyPath: "__req", autoIncrement: false });
            }

        };
        conn.onsuccess = (event) => {
            const db = event.target.result;

            if (!db.objectStoreNames.contains(this.docName)) {
                this.open(path, req, successCallback, errorCallback, db.version+1);
                return;
            }

            successCallback(db);
        }
    }

    esc(str) {
        return btoa(str);
    }

    get(path, req, successCallback, errorCallback) {
        this.open(path, req, (db) => {
            try {
                const transaction = db.transaction(this.docName, "readonly");
                const objectStore = transaction.objectStore(this.docName);
                let getRequest = objectStore.get(this.esc(path+req));
                getRequest.onsuccess = function (event) {
                    const record = event.target.result;
                    successCallback(record);
                };

                // Optional: handle errors
                getRequest.onerror = function (event) {
                    console.error("Error getting record:", event.target.error);
                    errorCallback?.(event.target.error);
                };
            }
            catch (e) {
                errorCallback(e);
            }
        });
    }

    async getAsync(path, req) {
        return new Promise((resolve, reject) => {
            this.get(path, req, (result) => {
                resolve(result);
            }, (err) => {
                reject(err);
            });
        });
    }

    put(path, req, data, successCallback, errorCallback) {
        this.open(path, req, (db) => {
            try {

                const transaction = db.transaction(this.docName, "readwrite");
                const objectStore = transaction.objectStore(this.docName);

                data.__req = this.esc(path+req);
                data.__qdt = new Date();
                let getRequest = objectStore.put(data);

                getRequest.onsuccess = function (event) {
                    const record = event.target.result;
                    successCallback?.(record);
                };

                // Optional: handle errors
                getRequest.onerror = function (event) {
                    console.error("Error writing record:", event.target.error);
                    errorCallback?.(event.target.error);
                };
            }
            catch (e) {
                console.error(e);
                errorCallback?.(e);
            }
        }, (e) => {
            errorCallback?.(e);
        });
    }

    async putAsync(path, req, data) {
        return new Promise((resolve, reject) => {
            this.put(path, req, data, (result) => {
                resolve(result);
            }, (err) => {
                resolve();
            });
        });
    }
}